export default "static/media/firefighter.46dc8ac.png"